"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var createOptions = function (inputVal) { return inputVal
    .split(',')
    .filter(function (value) { return value.trim().length; })
    .map(function (value) { return ({
    label: value,
    value: value,
}); }); };
var useCreateSelectOptions = function (_a) {
    var _b = _a.value, value = _b === void 0 ? [] : _b, onChange = _a.onChange;
    var _c = react_1.useState(''), inputValue = _c[0], setInputValue = _c[1];
    var handleKeyDown = function (event) {
        if (!inputValue) {
            return;
        }
        switch (event.key) {
            case 'Enter':
            case 'Tab':
                onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArrays(value, createOptions(inputValue)));
                setInputValue('');
                event.preventDefault();
        }
    };
    return {
        inputValue: inputValue,
        onInputChange: function (nextInputValue, meta) {
            setInputValue(nextInputValue);
            if (meta.action === 'input-blur' && meta.prevInputValue) {
                onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArrays(value, createOptions(meta.prevInputValue)));
            }
        },
        multi: true,
        value: value,
        onChange: onChange,
        onKeyDown: handleKeyDown,
        placeholder: 'Type values seperated by a comma',
        dropdownIcon: null,
    };
};
exports.default = useCreateSelectOptions;
